import apiClient from '@u/apiClient'
import SetCompanyPeppolProviderController from '@/wayfinder/actions/App/Http/Controllers/Partner/Peppol/SetCompanyPeppolProviderController'
import RegisterCompanyToBcSolutionsController from '@/wayfinder/actions/App/Http/Controllers/Partner/BcSolutions/RegisterCompanyToBcSolutionsController'
import GetCompanyBcSolutionsStatusController from '@/wayfinder/actions/App/Http/Controllers/Partner/BcSolutions/GetCompanyBcSolutionsStatusController'
import RestartCompanyBcSolutionsOnboardingController from '@/wayfinder/actions/App/Http/Controllers/Partner/BcSolutions/RestartCompanyBcSolutionsOnboardingController'

export default {
  setPeppolProvider({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          SetCompanyPeppolProviderController.post({ company: payload.id }),
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  registerCompanyToBcSolutions({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          RegisterCompanyToBcSolutionsController.post({ company: payload.id }),
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getBcSolutionsPeppolStatus({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetCompanyBcSolutionsStatusController.get({ company: payload.id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  restartBcSolutionsOnboarding({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          RestartCompanyBcSolutionsOnboardingController.post({
            company: payload.id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
